import { useMemo } from "react";
import { OrganizationsClient } from "@/features/organizations/api/organizations-client";

export function useOrganizationsClient() {
  return useMemo(() => new OrganizationsClient(), []);
}
